import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { AssistenzaService } from 'app/services/assistenza.service';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'app-list-assistenza',
  templateUrl: './list-assistenza.component.html',
  styleUrls: ['./list-assistenza.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]

})
export class ListAssistenzaComponent implements OnInit {

  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('statusTpl') statusTpl: TemplateRef<any>;
  @ViewChild('messageTpl') messageTpl: TemplateRef<any>;

  @ViewChild('hdrTplWithStatusSearch') hdrTplWithStatusSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithDateSearch') hdrTplWithDateSearch: TemplateRef<any>;

  profiledata: any;
  assistenzaList: {};
  rows = [];
  columns = [];
  adminUser: Boolean = false;
  temp = [];
  dataRows = [];
  excelRows = [];

  display = 'none'; //default Variable


  defaultSort = [
    {
      prop: 'insertDateTime',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(private router: Router,
    private assistenzaService: AssistenzaService,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private auth: AuthService,
    private datePipe: DatePipe) {

    this.spinnerService.start();

    this.adminUser = this.auth.isAdmin();
    this.assistenzaService.getAssistenzaParentListByUser(this.adminUser).subscribe(data => {
      this.rows = data.list;
      this.dataRows = data.list;
      /* console.log(this.rows); */
      this.spinnerService.stop();
    });
  }

  ngAfterViewInit(): void {
    let dateLength = 250, subjectLength = 200, messageLength = 200, statusLength = 120, actionLength = 120;
    if (this.adminUser) {
      dateLength = 250;
      subjectLength = 200;
      messageLength = 200;
      statusLength = 120;
      actionLength = 140;
    }

    this.columns = [
      {
        name: 'Data', prop: 'insertDateTime', headerTemplate: this.hdrTplWithDateSearch, sortable: true,
        resizeable: false, comparator: this.columnInsertDateTimeComparator.bind(this), width: dateLength
      },
      { name: 'Oggetto', prop: 'subject', sortable: true, resizeable: false, width: subjectLength },
      { name: 'Messaggio', cellTemplate: this.messageTpl, sortable: true, resizeable: false, width: messageLength },
      {
        name: 'Stato', cellTemplate: this.statusTpl, headerTemplate: this.hdrTplWithStatusSearch,
        sortable: true, resizeable: false, width: statusLength
      },
      { name: 'Actions', sortable: false, cellTemplate: this.actionCellTpl, resizeable: false, width: actionLength }
    ];
    if (this.adminUser) {
      this.columns.splice(1, 0, { name: 'Cliente', prop: 'userId', sortable: true, resizeable: false, width: 250 })
    }

    /* console.log(this.columns); */

  }

  ngOnInit() {
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.LIST_ASSISTANZA");
  }

  openModalDialog() {

    this.display = 'block'; //Set block css
  }
  closeModalDialog() {
    this.display = 'none'; //set none css after close dialog
  }

  addAssistanza() {
    this.spinnerService.start();
    this.router.navigate([`help/create`]);
  }

  manageAssistanza(threadId) {
    this.spinnerService.start();
    this.router.navigate([`help/detail/` + threadId]);
  }

  columnInsertDateTimeComparator(propA, propB, rowA, rowB) {
    if (rowA.insertDateTime < rowB.insertDateTime) { return -1; }
    if (rowA.insertDateTime > rowB.insertDateTime) { return 1; }
  }

  previousStatusFilter = '';
  previousDateFilterFrom: Date = null;
  previousDateFilterTo: Date = null;

  filterRows(event, columnName) {

    /* console.log(event.target.name); */
    var searchVal = event.target.value;

    switch (columnName) {
      case "Stato":
        this.previousStatusFilter = searchVal;
        break;
      case "Data":
        if (searchVal != '') {
          switch (event.target.name) {
            case "filterDateCreatedFrom":
              var selectedDate = new Date(searchVal);
              selectedDate.setHours(0, 0, 0, 0);
              this.previousDateFilterFrom = selectedDate;
              break;
            case "filterDateCreatedTo":
              var selectedDate = new Date(searchVal);
              selectedDate.setHours(0, 0, 0, 0);
              this.previousDateFilterTo = selectedDate;
              break;
          }
        }
        break;
    }

    this.temp = this.dataRows;
    this.rows = this.temp.filter(row => {

      const isPartialStatusMatch = !this.previousStatusFilter || (row.status && row.status === this.previousStatusFilter);
      const [dateComponents, timeComponents] = row.insertDateTime.split(' ');
      const [day, month, year] = dateComponents.split('/');
      var rowDate = new Date(+year, +month - 1, +day);

      var isPartialCreationDateMatch: boolean;
      if (this.previousDateFilterFrom != null && this.previousDateFilterTo != null) {
        isPartialCreationDateMatch = rowDate >= this.previousDateFilterFrom && rowDate <= this.previousDateFilterTo;
      } else if (this.previousDateFilterFrom != null) {
        isPartialCreationDateMatch = rowDate >= this.previousDateFilterFrom;
      } else if (this.previousDateFilterTo != null) {
        isPartialCreationDateMatch = rowDate <= this.previousDateFilterTo;
      }
      return isPartialStatusMatch && isPartialCreationDateMatch && isPartialCreationDateMatch;
    });
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Richieste', this.excelRows, "Lista richieste - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Lista richieste - HRWE.pdf");
    
  }

  exportRows() {

    if (this.adminUser) {
      this.header = ['Data', 'Cliente', 'Oggetto', 'Messaggio', 'Stato'];
      let arr = this.rows.map(row => {
        return {
          'Data': row.insertDateTime,
          'Cliente': row.userId,
          'Oggetto': row.subject,
          'Messaggio': row.message,
          'Stato': this.commonUtilService.decodeAssistenzaStatus(row.status),
        }
      });
      return arr;
    } else {
      this.header = ['Data', 'Oggetto', 'Messaggio', 'Stato'];
      let arr = this.rows.map(row => {
        return {
          'Data': row.insertDateTime,
          'Oggetto': row.subject,
          'Messaggio': row.message,
          'Stato': this.commonUtilService.decodeAssistenzaStatus(row.status),
        }
      });
      return arr;
    }

  }

}
